function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.137 32.89H67.61v12.474H55.137V32.89z",
  fill: "#C0C3C9"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M81.662 39.5c0 11.228-9.103 20.33-20.331 20.33C50.102 59.83 41 50.729 41 39.5c0-11.228 9.102-20.33 20.33-20.33 11.23 0 20.332 9.102 20.332 20.33zm-2.624 0c0 9.78-7.927 17.708-17.707 17.708-9.78 0-17.708-7.928-17.708-17.708 0-9.78 7.928-17.707 17.708-17.707 9.78 0 17.707 7.928 17.707 17.707z",
  fill: "#C0C3C9"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M89.13 32.974c1.602-1.719 3.534-2.566 5.84-2.566 2.436 0 4.631 1.22 6.19 3.24l-2.305 2.217c-1.032-1.32-2.327-1.968-3.886-1.968-1.36 0-2.502.523-3.446 1.57-.944 1.046-1.405 2.342-1.405 3.912 0 1.57.46 2.866 1.383 3.912.944 1.022 2.085 1.545 3.468 1.545 1.58 0 2.876-.673 3.908-1.993l2.305 2.217c-1.559 2.069-3.776 3.265-6.213 3.265-2.305 0-4.237-.847-5.84-2.542-1.602-1.72-2.392-3.837-2.392-6.404 0-2.567.79-4.685 2.393-6.404zM105.966 30.682V48.05h-3.271V30.68h3.271z",
  fill: "#C0C3C9"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M113.825 35.117c-1.712 0-3.161.649-4.368 1.944-1.186 1.271-1.778 2.841-1.778 4.71 0 1.87.592 3.439 1.778 4.735 1.207 1.27 2.656 1.919 4.368 1.919 1.691 0 3.14-.648 4.347-1.92 1.208-1.295 1.8-2.865 1.8-4.734 0-1.869-.592-3.439-1.8-4.71-1.207-1.295-2.656-1.944-4.347-1.944zm-2.875 6.654c0-.922.285-1.694.834-2.317.549-.648 1.229-.972 2.041-.972.813 0 1.493.324 2.042.972.549.623.834 1.395.834 2.317 0 .922-.285 1.695-.834 2.343-.549.623-1.229.947-2.042.947-.812 0-1.492-.325-2.041-.947-.549-.623-.834-1.42-.834-2.343z",
  fill: "#C0C3C9"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M123.094 47.004c-1.01-.922-1.515-2.267-1.515-4.012v-7.5h3.315v7.176c0 1.595.813 2.318 2.02 2.318s2.02-.723 2.02-2.318v-7.177h3.315v7.501c0 1.745-.505 3.09-1.537 4.012-1.01.922-2.283 1.396-3.798 1.396-1.515 0-2.788-.474-3.82-1.396z",
  fill: "#C0C3C9"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.343 35.267c-1.559 0-2.876.623-3.929 1.894-1.032 1.246-1.559 2.791-1.559 4.61 0 1.82.527 3.364 1.559 4.635 1.053 1.246 2.37 1.87 3.929 1.87 1.669 0 2.964-.773 3.293-1.87v1.645h3.271V30.68h-3.271v6.455c-.329-1.096-1.624-1.869-3.293-1.869zm.593 9.644c-.79 0-1.449-.3-1.998-.897-.549-.623-.812-1.37-.812-2.243 0-.872.263-1.62.812-2.218.549-.623 1.208-.922 1.998-.922.812 0 1.493.3 2.042.922.57.598.856 1.346.856 2.218 0 .872-.286 1.62-.856 2.243a2.66 2.66 0 01-2.042.897z",
  fill: "#C0C3C9"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M153.436 48.325c-3.095 0-5.246-1.57-6.278-3.838l2.459-1.919c.812 1.52 2.085 2.293 3.841 2.293 1.559 0 2.283-.797 2.283-1.72 0-.647-.329-1.096-.834-1.445-.285-.224-.9-.523-1.317-.648-.189-.088-.507-.215-.832-.344a21.686 21.686 0 01-.858-.353c-2.393-.997-3.71-2.417-3.71-5.034 0-1.495.483-2.691 1.471-3.564.987-.897 2.195-1.345 3.622-1.345 2.217 0 3.907.947 5.093 2.84l-2.261 1.944c-.615-.897-1.537-1.345-2.744-1.345-1.12 0-1.844.598-1.844 1.42 0 .573.131.922.592 1.246.242.15.483.274.681.374l1.097.423c.505.2.944.374 1.318.549 2.788 1.196 3.907 2.666 3.907 5.158 0 3.215-1.932 5.308-5.686 5.308zM164.085 48.05V41c0-1.47.835-2.492 2.042-2.492 1.207 0 1.888.897 1.888 2.367v7.177h3.271v-7.626c0-3.264-1.493-5.208-4.105-5.208-1.471 0-2.657.698-3.096 1.794v-6.33h-3.271v17.37h3.271z",
  fill: "#C0C3C9"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M174.715 37.061c1.208-1.295 2.657-1.944 4.369-1.944 1.69 0 3.139.649 4.347 1.944 1.207 1.271 1.8 2.841 1.8 4.71 0 1.87-.593 3.439-1.8 4.735-1.208 1.27-2.657 1.919-4.347 1.919-1.712 0-3.161-.648-4.369-1.92-1.185-1.295-1.778-2.865-1.778-4.734 0-1.869.593-3.439 1.778-4.71zm2.327 2.393c-.548.623-.834 1.395-.834 2.317 0 .922.286 1.72.834 2.343.549.623 1.23.947 2.042.947.812 0 1.493-.325 2.042-.947.548-.648.834-1.42.834-2.343 0-.922-.286-1.694-.834-2.317-.549-.648-1.23-.972-2.042-.972-.812 0-1.493.324-2.042.972zM190.219 52.86v-6.454c.329 1.097 1.624 1.87 3.293 1.87 1.558 0 2.876-.624 3.907-1.87 1.054-1.27 1.581-2.816 1.581-4.635s-.527-3.364-1.581-4.61c-1.031-1.27-2.349-1.894-3.907-1.894-1.669 0-2.964.773-3.293 1.869v-1.645h-3.271v17.37h3.271zm2.7-7.949c-.812 0-1.493-.3-2.064-.897-.548-.623-.834-1.37-.834-2.243 0-.872.286-1.62.834-2.218.571-.623 1.252-.922 2.064-.922.79 0 1.449.3 1.998.922.549.598.812 1.346.812 2.218 0 .872-.263 1.62-.812 2.243-.549.598-1.208.897-1.998.897z",
  fill: "#C0C3C9"
});

var SvgCloudshopG = function SvgCloudshopG(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 240 80",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloudshopG, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloudshop_g.95c623e1.svg";
export { ForwardRef as ReactComponent };